import { RouterPaths } from "../config/router-paths.model";
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
var NavigationService = /** @class */ (function () {
    function NavigationService(router) {
        this.router = router;
    }
    NavigationService.prototype.goToHomePage = function () {
        this.changePageSavingQueryParams(RouterPaths.home);
        //this.mainTabsService.resetActiveTab();
    };
    NavigationService.prototype.goToSettingsPage = function () {
        this.changePageSavingQueryParams(RouterPaths.settings);
    };
    NavigationService.prototype.goToTermsPage = function () {
        this.changePageSavingQueryParams(RouterPaths.termsAndConditions);
    };
    NavigationService.prototype.goToSupport = function () {
        this.changePageSavingQueryParams(RouterPaths.support);
    };
    NavigationService.prototype.changePageSavingQueryParams = function (url) {
        this.router.navigate([url], { queryParamsHandling: "merge" });
    };
    NavigationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NavigationService_Factory() { return new NavigationService(i0.ɵɵinject(i1.Router)); }, token: NavigationService, providedIn: "root" });
    return NavigationService;
}());
export { NavigationService };
